<script>
import * as dayjs from "dayjs";
import {planyTerapiiService} from "@/services/planyTerapii.service";
import ZadaniePlanowZdrowieniaEdit from "@/components/clients/ZadaniePlanowZdrowieniaEdit.vue";

export default {
  name: "ZadaniaPlanowZdrowienia",
  components: {ZadaniePlanowZdrowieniaEdit},
  props: ["plan_zdrowienia_id"],
  data() {
    return {
      zadania: [],
      cele: [],
      loading: false,
      edytowany: null,
      title_edycja_tworzenie: 'Nowe zadanie',
      nowe_zadanie_dialog: false,
      headers: [
        { text: 'Nazwa', value: 'nazwa' },
        { text: 'Nazwa celu', value: 'id'},
        { text: 'Status', value: 'status' },
        { text: 'Opis', value: 'opis' },
        { text: 'Data utworzenia', value: 'dataUtworzenia' },
        { text: 'Data zakończenia/anulacji', value: 'dataZakoczeniaAnulacji' },
        { text: 'Akcje', value: 'id' },
      ],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getFormattedDate(val)
    {

      if(val) {
        let dj = dayjs(val)

        if (dj != null) {
          return dj.format("DD-MM-YYYY")
        } else {
          return ''
        }
      }
      return ''
    },
    getStatusDescription(status) {
      switch (status){
        case 0:
          return 'Planowany';
        case 1:
          return 'Realizowany';
        case 2:
          return 'Zrealizowany';
        case 3:
          return 'Anulowany';
      }
      return '';
    },
    dodajZadanie() {
      this.edytowany = null
      this.nowe_zadanie_dialog = true
    },
    getData() {
      this.loading = true
      planyTerapiiService.getPlanTerapiiZadanie(this.plan_zdrowienia_id).then((response) => {
        this.zadania = response.data.result
        this.loading = false
      }).catch(() => {
        this.showError('Bład pobierania zadań terapii')
        this.loading = false
      })

      this.loading = true
      planyTerapiiService.getPlanTerapiiCel(this.plan_zdrowienia_id).then((response) => {
        this.cele = response.data.result
        this.loading = false
      }).catch(() => {
        this.showError('Bład pobierania celów terapii')
        this.loading = false
      })
    },
    editZadanie(item) {
      this.edytowany = item
      this.nowe_zadanie_dialog = true
    },
    closeEdit() {
      this.nowe_zadanie_dialog = false
      this.edytowany = null
      this.getData()
    }
  }
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dodajZadanie" v-if="cele && cele.length > 0">Nowe zadanie</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="zadania"
            :loading="loading"
            class="elevation-1"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.nazwa}}</td>
              <td>{{props.item.cel.nazwa}}</td>
              <td>{{getStatusDescription(props.item.status)}}</td>
              <td>{{props.item.opis}}</td>
              <td>{{getFormattedDate(props.item.dataUtworzenia)}}</td>
              <td>{{getFormattedDate(props.item.dataZakoczeniaAnulacji)}}</td>
              <td><v-icon small class="mr-2" v-if="cele && cele.length > 0" @click="editZadanie(props.item)" color="primary"  title="Sprawdź szczegóły zadania">fa-edit</v-icon></td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="nowe_zadanie_dialog">
      <v-dialog v-model="nowe_zadanie_dialog" persistent max-width="720px">
        <v-card>
          <v-toolbar dark class="primary">
            <v-btn icon @click.native="nowe_zadanie_dialog = false" dark>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>{{title_edycja_tworzenie}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <ZadaniePlanowZdrowieniaEdit v-if="nowe_zadanie_dialog" :plan_zdrowienia_id="plan_zdrowienia_id" :edytowane_zadanie="edytowany" :cele="cele" @close="closeEdit"></ZadaniePlanowZdrowieniaEdit>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>